import { PropTypes } from "prop-types";
import { Col, Row } from "react-grid-system";
import { StyledModalFooterActions } from "../../styles/StyledAddUpperDecision";
import { Button } from "../Button";
import DeleteIcon from "../../assets/img/icons/delete-green.svg";

export default function ConfirmationModal({ handleDelete, deletedId, closeModal }) {
	return (
		<>
			<h2>Are you sure?</h2>
			<Row>
				<Col>
					<StyledModalFooterActions>
						<Button onClick={() => closeModal()} bg={false} small={true}>
							Cancel
						</Button>
						<Button
							icon={DeleteIcon}
							onClick={() => {
								handleDelete(deletedId ? deletedId : undefined);
								closeModal();
							}}
						>
							Confirm
						</Button>
					</StyledModalFooterActions>
				</Col>
			</Row>
		</>
	);
}

ConfirmationModal.propTypes = {
	handleDelete: PropTypes.func,
	closeModal: PropTypes.func,
	deletedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
};
